import {skipToken} from '@reduxjs/toolkit/query';
import {Text} from 'platform/foundation';

import {useGetMakeModelWithMakeQuery} from '@dms/api/sales';
import i18n, {FALLBACK_LANGUAGE} from '@dms/i18n';
import {getVehicleLabels} from '@dms/shared';

import {isCatalogueMakeKey} from '../utils/isCatalogueMakeKey';

interface CatalogueMakeLabelProps {
  vehicleType: string;
  make: string;
}

export function CatalogueMakeLabel(props: CatalogueMakeLabelProps) {
  const {data: catalogue} = useGetMakeModelWithMakeQuery(
    isCatalogueMakeKey(props.make)
      ? {
          vehicleType: props.vehicleType,
          make: props.make,
          lang: [i18n?.resolvedLanguage ?? FALLBACK_LANGUAGE],
        }
      : skipToken
  );

  return (
    <Text size="small">{getVehicleLabels({make: props.make}, catalogue).make ?? props.make}</Text>
  );
}
